import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { BreadCrum } from "../../common";
import { useDispatch, useSelector } from "react-redux";
import CommonTable from "../../common/CommonTable";
import { claimsListColumns } from "./claimUtils";
import { getProductFeatureContentHandler } from "../../redux/action/getProductFeatureContentSlice";
import Loader from "../../components/Loder/loader";
import { getItem } from "../../common/localStorage";
import { navigateToProductParent } from "./productNavigation";
import { useAdminPermissions } from "../../hooks/useAdminPermissions";

const Claim = () => {
  const [handleClaimList, setHandleClaimList] = useState([]);
  const { state } = useLocation();
  const dispatch = useDispatch();
  const getProductFeatureContent = useSelector(
    (state) => state?.getProductFeatureContentMain
  );

  const navigate = useNavigate();
  const { hasProductViewOnly, canEditProducts } = useAdminPermissions();
  const dashBoardColumnsData = claimsListColumns(navigate, {
    showManage: canEditProducts,
    showView: hasProductViewOnly,
    fromClaim: state,
  });

  const addClaim = () => {
    navigate("/Add-claim", { state: { fromClaim: state } });
  };

  const getProductId = getItem("productId");
  const refFeatureId = getItem("refFeatureId");

  const getProductFeatureFunction = () => {
    if (Number(getProductId) && Number(refFeatureId)) {
      let payload = {
        productId: Number(getProductId) || state?.state?.productData?.productId,
        refFeatureId:
          state?.state?.refFeatureId ||
          state?.refFeatureId ||
          Number(refFeatureId),
      };
      dispatch(getProductFeatureContentHandler(payload));
    }
  };

  useEffect(() => {
    getProductFeatureFunction();
  }, []);

  useEffect(() => {
    const claimListData = getProductFeatureContent?.data?.data?.content?.claim?.map(item => ({
      claimName: item?.claimName,
      claimType: item?.claimType,
      language: item?.language,
      urlData: item?.urlData,
      claimStatus: item?.claimStatus?.charAt(0)?.toUpperCase() + item?.claimStatus?.slice(1)?.toLowerCase(),
      id: item?.id,
      productId: getProductFeatureContent?.data?.data?.productId,
      itemStored: item,
    })).reverse();

    setHandleClaimList(claimListData);
  }, [getProductFeatureContent]);

  return (
    <>
      {getProductFeatureContent?.isLoading === true && (
        <Loader loaderTransForm="loaderTransForm" />
      )}
      <div className="rightside">
        <div className="rightcontent">
          <p>
            <strong>Products</strong>
          </p>

          <CustomBreadcrumb
            items={[
              { text: BreadCrum.HOME },
              { text: BreadCrum.PRODUCTS, onClick: () => { navigate("/product"); localStorage.removeItem("productId") } },
              { text: BreadCrum.MANAGE_PRODUCTS, onClick: () => navigateToProductParent(navigate, state) },
              { text: BreadCrum.CLAIM_LIST, active: true },
            ]}
          />
          <div className="table-padding">
            <div className="headtitle">
              <p className="mb-0 heedprodct">Claims</p>
              {canEditProducts && (
                <button className="primarybtn" onClick={addClaim}>
                  <div className="plus"></div>
                  Add
                </button>
              )}
            </div>
            <hr className="m-0" />
            <div className="table-responsive">
              <CommonTable
                body={handleClaimList}
                columns={dashBoardColumnsData}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Claim;
